import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import configApi from '../../config';

ChartJS.register(ArcElement, Tooltip, Legend);

const RevenuePieChart = () => {
    const [chartData, setChartData] = useState({});
    const token = localStorage.getItem("token");
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    useEffect(() => {
        const fetchRevenueData = async () => {
            try {
                const response = await axios.get(
                    `${configApi.apiEndpoint}/api/Stats/RevenueByTermType`,
                    config
                );

                const labels = response.data.map(item => item.termTypeName || item.TermTypeName);
                const data = response.data.map(item => item.totalRevenue || item.TotalRevenue);

                setChartData({
                    labels: labels,
                    datasets: [
                        {
                            label: 'Celková Tržba (€)',
                            data: data,
                            backgroundColor: [
                                '#4caf50',
                                '#81c784',
                                '#aed581',
                                '#dce775',
                                '#fff59d',
                                '#ffb74d'
                            ],
                            borderColor: [
                                '#388e3c',
                                '#66bb6a',
                                '#9ccc65',
                                '#d4e157',
                                '#fff176',
                                '#ffa726'
                            ],
                            borderWidth: 1,
                        },
                    ],
                });
            } catch (error) {
                console.error('Error fetching revenue by term type:', error);
            }
        };

        fetchRevenueData();
    }, []);

    return (
        <div className="card-custom h-100">
            <div className="card-custom-header">
                <h5>Tržby podľa služby</h5>
            </div>
            <div className="p-3" style={{ height: '300px', display: 'flex', justifyContent: 'center' }}>
                {chartData.labels && chartData.labels.length > 0 ? (
                    <Pie data={chartData} options={{ maintainAspectRatio: false }} />
                ) : (
                    <p className="text-muted text-center align-self-center">Nie sú dostupné žiadne údaje.</p>
                )}
            </div>
        </div>
    );
};

export default RevenuePieChart;
